import { jsx as _jsx } from "react/jsx-runtime";
export const DuplicateIcon = _ref => {
  let {
    size = '22'
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    width: size,
    height: size,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M14.75 11.65V15.85C14.75 19.35 13.35 20.75 9.85 20.75H5.65C2.15 20.75 0.75 19.35 0.75 15.85V11.65C0.75 8.15 2.15 6.75 5.65 6.75H9.85M14.75 11.65C14.75 8.15 13.35 6.75 9.85 6.75M14.75 11.65V14.75H15.85C19.35 14.75 20.75 13.35 20.75 9.85V5.65C20.75 2.15 19.35 0.75 15.85 0.75H11.65C8.15 0.75 6.75 2.15 6.75 5.65V6.75H9.85",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};